// Check if class doesn't exist
if (!customElements.get('image-reveal')) {
  class ImageReveal extends HTMLElement {
    constructor() {
      super();

      this.setupInputEvent();
    }

    setupInputEvent() {
      this.inputEl = this.querySelector('input[type="range"]');

      this.inputEl.addEventListener('input', () => {
        this.updateImageRevealElements();
      });
    }

    updateImageRevealElements() {
      const percentage = this.inputEl.value + '%';

      const overlayImage = document.getElementById(this.inputEl.dataset.targetOverlayImageId);
      const revealButton = document.getElementById(this.inputEl.dataset.targetRevealButtonId);
      const revealSeparator = document.getElementById(this.inputEl.dataset.targetSeparatorId);

      if (!overlayImage || !revealButton || !revealSeparator) {
        return;
      }

      // Update styles
      overlayImage.style.width = percentage;
      revealButton.style.left = percentage;
      revealSeparator.style.left = percentage;
    }
  }

  customElements.define('image-reveal', ImageReveal);
}
